// extracted by mini-css-extract-plugin
export default {"menuIcon":"DotMenu_menuIcon__SYvGq","dotMenu":"DotMenu_dotMenu__yjj3R"};